export const Types = {
  SAVE_LIST_PRIORITIES: 'SAVE_LIST_PRIORITIES',
  SAVE_LIST_PRIORITY_BENEFITS: 'SAVE_LIST_PRIORITY_BENEFITS',
  SAVE_LIST_PRIORITY_REQUESTS: 'SAVE_LIST_PRIORITY_REQUESTS',
  SAVE_LIST_PRIORITY_USERS: 'SAVE_LIST_PRIORITY_USERS',
  SAVE_LIST_DETAIL_PRIORITY_REQUESTS: 'SAVE_LIST_DETAIL_PRIORITY_REQUESTS',
}
